import { render, staticRenderFns } from "./FarmEdit.vue?vue&type=template&id=5b33754e&"
import script from "./FarmEdit.vue?vue&type=script&lang=js&"
export * from "./FarmEdit.vue?vue&type=script&lang=js&"
import style0 from "./FarmEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports